module.exports = __webpack_public_path__ + "img/logo.e351e636.png";